import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 bg-surface" data-id="element-11">
      <div className="max-w-7xl mx-auto px-6" data-id="element-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-13">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} data-id="element-14">
            <h2 className="text-3xl md:text-4xl font-semibold mb-6" data-id="element-15">
              Про мене
            </h2>
            <p className="text-lg text-secondary leading-relaxed mb-6 font-medium text-primary" data-id="element-16">
              Я спеціалізуюсь виключно на бухгалтерському обліку для ФОП. Без
              зайвих послуг — тільки те, що реально потрібно вашому бізнесу.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-17">
            <div className="bg-background p-6 rounded-2xl border border-border flex flex-col items-center justify-center text-center hover:border-primary/30 transition-colors" data-id="element-18">
              <div className="text-2xl lg:text-3xl font-semibold text-primary mb-2" data-id="element-19">
                10+ років
              </div>
              <div className="text-sm text-secondary leading-tight font-medium" data-id="element-20">
                Досвід роботи
              </div>
            </div>

            <div className="bg-background p-6 rounded-2xl border border-border flex flex-col items-center justify-center text-center hover:border-primary/30 transition-colors" data-id="element-21">
              <div className="text-2xl lg:text-3xl font-semibold text-primary mb-2" data-id="element-22">
                Всі форми
              </div>
              <div className="text-sm text-secondary leading-tight font-medium" data-id="element-23">
                Оподаткування ФОП
              </div>
            </div>

            <div className="bg-background p-6 rounded-2xl border border-border flex flex-col items-center justify-center text-center hover:border-primary/30 transition-colors" data-id="element-24">
              <div className="text-2xl lg:text-3xl font-semibold text-primary mb-2" data-id="element-25">
                100%
              </div>
              <div className="text-sm text-secondary leading-tight font-medium" data-id="element-26">
                Конфіденційність
              </div>
            </div>

            <div className="bg-background p-6 rounded-2xl border border-border flex flex-col items-center justify-center text-center hover:border-primary/30 transition-colors" data-id="element-27">
              <div className="text-2xl lg:text-3xl font-semibold text-primary mb-2" data-id="element-28">
                Вся Україна
              </div>
              <div className="text-sm text-secondary leading-tight font-medium" data-id="element-29">
                Працюю дистанційно
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}